const live_Url = "https://f0xz180b38.execute-api.ap-south-1.amazonaws.com/Prod/api/";
const GetBaseUrl = () => {
   return live_Url;
}
export const DomainService = {
    GetBaseUrl
}